exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"menuText": "#333",
	"menuActiveText": "#55b2ff",
	"subMenuActiveText": "#333",
	"menuBg": "#fff",
	"menuHover": "#55b2ff",
	"subMenuBg": "#fff",
	"subMenuHover": "#55b2ff",
	"sideBarWidth": "210px"
};